import { inject, Injectable } from '@angular/core';
// Importe CanActivate em vez de KeycloakAuthGuard
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import Keycloak from 'keycloak-js';

@Injectable
({
  providedIn: 'root'
})
// 1. Implemente a interface CanActivate
export class AdminGuard implements CanActivate {

  // 2. O construtor agora é mais simples, sem chamada super()
  constructor(
    private readonly router: Router,
  ) {}
  private readonly keycloak = inject(Keycloak)
  
  // 3. O método agora se chama 'canActivate'
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    
    // Verifique se o usuário está logado usando o serviço
    const authenticated = await this.keycloak.authenticated;

    if (!authenticated) {
      // Se não estiver logado, redirecione para o login
      await this.keycloak.login({
        redirectUri: window.location.origin + state.url
      });
      return false; // Impede a navegação
    }

    // O resto da sua lógica personalizada continua aqui
    const tokenDecoded = await this.decodeToken();
    if (!tokenDecoded) {
        // Token inválido, força o login novamente
        await this.keycloak.login({ redirectUri: window.location.origin + state.url });
        return false;
    }

    const requiredRoles = route.data['roles'];

    if (!Array.isArray(requiredRoles) || requiredRoles.length === 0) {
      return true;
    }
    
    // verificar que isso foi alterado para utilizar role do usuario -- resource access
    const hasRole = requiredRoles.some((role) =>
      tokenDecoded.permissions?.includes(role)
    );

    let clientId = tokenDecoded.aud;

    if (Array.isArray(clientId)) {
      // pega o primeiro client que não seja "app-home"
      clientId = clientId.find((aud: string) => aud !== "app-home" && aud !== "account") ?? "";
    }

    const roles = tokenDecoded.resource_access?.[clientId]?.roles || [];


    if (!roles) {
        // Opcional: Redirecionar para uma página de "acesso negado"
        this.router.navigate(['/acesso-negado']);
        return false;
    }

    return true;
  }
  
  // Seus métodos de ajuda continuam os mesmos
  async decodeToken(): Promise<any> {
    const tokenJwt = await this.keycloak.token;
    if (tokenJwt) {
      const payload = this.parseJwt(tokenJwt);
      return payload;
    }
    return null;
  }

  private parseJwt(token: string): any {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }
}